window.DASHBOARD_TRACKING_SWITCHER = {
    options: {},
    showDots: false,
    showLines: true,
    init: function (options) {
        _.extend(window.DASHBOARD_TRACKING_SWITCHER.options, options);
        // Add a BlackDot/RedLine switcher button
        L.Control.TrackingSwitcher = L.Control.extend({
            option: {
                icon: {
                    'dotsEnabled': '⬤',
                    'linesEnabled': '❌',
                    'dotsDisabled' : '⭘',
                    'linesDisabled' : '⦻',
                },
            },
            onAdd: function(map) {
                var container = L.DomUtil.create('div', 'leaflet-control-tracker-switcher leaflet-bar leaflet-control');

                this.linkDots = L.DomUtil.create('a', 'leaflet-control-tracker-switcher-button leaflet-bar-part', container);
                this.linkDots.href = '#';
                this.linkDots.text = DASHBOARD_TRACKING_SWITCHER.showDots ? this.option.icon.dotsEnabled : this.option.icon.dotsDisabled;

                this.linkLines = L.DomUtil.create('a', 'leaflet-control-tracker-switcher-button leaflet-bar-part', container);
                this.linkLines.href = '#';
                this.linkLines.text = DASHBOARD_TRACKING_SWITCHER.showLines ? this.option.icon.linesEnabled : this.option.icon.linesDisabled;

                L.DomEvent.on(this.linkLines, 'click', this._clickLines, this);
                L.DomEvent.on(this.linkDots, 'click', this._clickDots, this);

                return container;
            },

            onRemove: function (map) {
                L.DomEvent.off(this.linkLines, 'click', this._clickLines, this);
                L.DomEvent.off(this.linkDots, 'click', this._clickDots, this);
            },

            _clickLines: function (e) {
                L.DomEvent.stopPropagation(e);
                L.DomEvent.preventDefault(e);
                if(DASHBOARD_TRACKING_SWITCHER.showLines) {
                    // Switching from Show to Hide
                    DASHBOARD_TRACKING_SWITCHER.showLines = false;
                    this.linkLines.text = this.option.icon.linesDisabled;
                    _.forEach(window.DASHBOARD_DRIVES.drives, function (drive) {
                        drive.removeLineFromMap();
                    });
                } else {
                    // Switching from Hide to Show
                    DASHBOARD_TRACKING_SWITCHER.showLines = true;
                    this.linkLines.text = this.option.icon.linesEnabled;

                    _.forEach(window.DASHBOARD_DRIVES.drives, function (drive) {
                        drive.show();
                    });
                }
            },

            _clickDots: function (e) {
                L.DomEvent.stopPropagation(e);
                L.DomEvent.preventDefault(e);
                if(DASHBOARD_TRACKING_SWITCHER.showDots) {
                    // Switching from Hide to Show
                    DASHBOARD_TRACKING_SWITCHER.showDots = false;
                    this.linkDots.text = this.option.icon.dotsDisabled;
                    _.forEach(window.DASHBOARD_DRIVES.drives, function (drive) {
                        drive.removeDotsFromMap();
                    });
                    window.DASHBOARD_MAP_LEGEND.hideDriveDashboardKey();
                } else {
                    // Switching from Show to Hide
                    DASHBOARD_TRACKING_SWITCHER.showDots = true;
                    this.linkDots.text = this.option.icon.dotsEnabled;
                    _.forEach(window.DASHBOARD_DRIVES.drives, function (drive) {
                        drive.show();
                    });
                    window.DASHBOARD_MAP_LEGEND.showDriveDashboardKey();
                }
            },
        });

        L.control.trackingSwitcher = function (opts) {
            return new L.Control.TrackingSwitcher(opts);
        }

        L.control.trackingSwitcher({ position: 'topleft' }).addTo(window.DASHBOARD_MAP.map);
    },
}
